(function Confirmations($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{

		Adzuki.onload('Confirmations/edit', function onload() {

			var passengerList = $('.passenger-list');
			var emptyMessage  = $('.empty-passenger-message');

			// for new reservation primary client look up
			$('.primary-client-search-select')
				.click(
					function clear() {
						$(this).val('');
						$('#confirmationtransfer-primary_client_id').val('');
					}
				)
			;

			if ($('.primary-client-search-select').length > 0) {
				Adzuki.Typeahead('.primary-client-search-select', '/Clients/search', function select(item, $self) {
					$('#confirmationtransfer-primary_client_id').val(item.id);
				});
			}

			// for confirmation passengers look up
			$('.client-search-select')
				.click(
					function clear() {
						var $container = $(this).parent('.form-group');

						$(this).val('');
						$container.find('.client-id').val('');
					}
				)
			;

			if ($('.client-search-select').length > 0) {
				Adzuki.Typeahead('.client-search-select', '/Clients/search', function select(item, $self) {
					var $container = $self.parent('.form-group');

					$container.find('.client-id').val(item.id);
					$container.find('.client-first-name').val(item.first_name);
					$container.find('.client-last-name').val(item.last_name);
				});
			}

			// add passenger to confirmation
			$('.add-passenger-btn')
				.click(
					function addPassenger() {
						var container       = $(this).parents('.add-passenger');
						var client_id       = $(container).find('.client-id').val();
						var client_first    = $(container).find('.client-first-name').val();
						var client_last     = $(container).find('.client-last-name').val();
						var price           = $(container).find('.client-price').val();
						var taxes_fees      = $(container).find('.client-taxes-fees').val();
						var travel_type     = $(container).find('.travel-type').val();
						var confirmation_id = $(container).find('.confirmation-type-id').val();

						Adzuki.Ajax
						.post(
							Adzuki.base_uri + '/Confirmations/addPassenger',
							{
								client_id      : client_id,
								first_name     : client_first,
								last_name      : client_last,
								price          : price,
								taxes_fees     : taxes_fees,
								travel_type    : travel_type,
								confirmation_id: confirmation_id,
							}
						).then(
							function success(data) {
								if (data.status) {
									console.log(data.status);
									console.log('error');
								}
								if (data && !data.status) {
									appendPassenger(data);
								}
							}
						);
					}
				)
			;

			$('.add-passenger-new-btn')
				.click(
					function addPassenger() {
						var container       = $(this).parents('.add-passenger');
						var client_first    = $(container).find('.client-first-name').val();
						var client_last     = $(container).find('.client-last-name').val();
						var price           = $(container).find('.client-price').val();
						var taxes_fees      = $(container).find('.client-taxes-fees').val();
						var travel_type     = $(container).find('.travel-type').val();
						var confirmation_id = $(container).find('.confirmation-type-id').val();

						Adzuki.Ajax
						.post(
							Adzuki.base_uri + '/Confirmations/addPassenger',
							{
								first_name     : client_first,
								last_name      : client_last,
								price          : price,
								taxes_fees     : taxes_fees,
								travel_type    : travel_type,
								confirmation_id: confirmation_id,
								new_client     : true,
							}
						).then(
							function success(data) {
								if (data.status) {
									console.log(data.status);
									console.log('error');
								}
								if (data && !data.status) {
									appendPassenger(data);
								}
							}
						);
					}
				)
			;

			function appendPassenger(passenger)
			{
				emptyMessage.hide();
				$(passenger).slideUp();
				$(passenger).appendTo(passengerList).slideDown();
			}

		});
	});
}(jQuery, window.Adzuki || {}));

